/* eslint-disable react/prop-types */
import React, { useState } from 'react';

import { Modal } from 'antd';
import TipPng from './tip.png';
import styles from './index.css';

const TipModal = (props) => {

  return (
    <Modal
        visible={props?.visible ?? false}
        wrapClassName={styles.modal}
        footer={null}
        onCancel={props?.onCancel}>
      <img src={TipPng} className={styles.img} />
    </Modal>);
};

export default TipModal;
